/**
 * When loaded matches are cleared (e.g. invalidateLoadedMatches) but the row
 * still thinks it fetched, reset so the load effect runs again.
 */
export function shouldResetTrackMatchFetchState(
  hasFetchedMatches: boolean,
  matchedTracks: unknown[] | undefined,
): boolean {
  return hasFetchedMatches && matchedTracks === undefined;
}

/** True while matches are missing but a refetch is expected or in flight. */
export function shouldShowTrackMatchesLoadingState(
  matchedTracks: unknown[] | undefined,
  hasFetchedMatches: boolean,
  isMatchRequestInFlight: boolean,
): boolean {
  if (matchedTracks !== undefined) {
    return false;
  }
  if (isMatchRequestInFlight) {
    return true;
  }
  return !hasFetchedMatches;
}

/**
 * Empty state after a completed fetch with no cached matches (timeout) or an empty result set.
 * Not shown while a refetch is pending after invalidation.
 */
export function shouldShowNoLocalMatchesEmptyState(
  matchedTracks: unknown[] | undefined,
  hasFetchedMatches: boolean,
  isMatchRequestInFlight: boolean,
): boolean {
  if (
    shouldShowTrackMatchesLoadingState(
      matchedTracks,
      hasFetchedMatches,
      isMatchRequestInFlight,
    )
  ) {
    return false;
  }
  if (!hasFetchedMatches) {
    return false;
  }
  if (matchedTracks === undefined) {
    return true;
  }
  return matchedTracks.length === 0;
}
